(() => {
  function findJudgeMeWidget() {
    return document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
  }

  function openJudgeMeForm(widget) {
    const nativeTrigger = widget?.querySelector('.jdgm-write-rev-link, [class*="write-rev"]') || document.querySelector('.jdgm-write-rev-link, [class*="write-rev"]');
    if (nativeTrigger) {
      nativeTrigger.click();
      return true;
    }
    return false;
  }

  function addReviewButton() {
    if (!document.querySelector('main[data-template*="product"]')) return;
    if (document.querySelector('[data-ksw-write-review]')) return;
    const widget = findJudgeMeWidget();
    const heading = document.querySelector('.ksw-reviews-heading');
    if (!widget || !heading) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ksw-write-review';
    button.textContent = 'Write a review';
    button.setAttribute('data-ksw-write-review', '');
    button.setAttribute('aria-controls', widget.id || 'judgeme_product_reviews');
    button.addEventListener('click', () => {
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (openJudgeMeForm(widget)) return;
      window.setTimeout(() => openJudgeMeForm(widget), 400);
      window.setTimeout(() => openJudgeMeForm(widget), 1000);
      window.setTimeout(() => openJudgeMeForm(widget), 1800);
    });
    heading.appendChild(button);
  }

  function init() {
    addReviewButton();
    const observer = new MutationObserver(addReviewButton);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
